export enum EmailDigestDialogActions {
    OPEN = 'OPEN',
    EDIT = 'EDIT',
    COPY = 'COPY'
}

export enum EmailDigestPreviweBoxActions {
    PREVIEW = 'PREVIEW',
}

export enum EmailDigestDialogEvents {
    SAVE = 'SAVE',
    CANCEL = 'CANCEL'
}

export enum SchedulerWeeklyOnSelectMode {
    MULTIPLE = 'multiple',
    SINGLE = 'single',
}

export enum EmailGridContextMenu {
    SHOW = 'SHOW'
}
